/*
 * @Author: xinian
 * @Date: 2022-03-28 09:15:31
 * @LastEditors: zhangyigong 947028660@qq.com
 * @LastEditTime: 2022-05-06 09:47:06
 * @FilePath: \xm-cms\src\router\index.ts
 */
import { createRouter, RouteRecordRaw, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      // 页面标题title
      title: "首页"
    }
  },
  {
    path: "/newsList",
    name: "newsList",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/NewsList.vue"),
    meta: {
      // 页面标题title
      title: "新闻列表"
    }
  },
  {
    path: "/newsDetail",
    name: "newsDetail",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/NewsDetail.vue"),
    meta: {
      // 页面标题title
      title: "新闻详情"
    }
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/AboutUs.vue"),
    meta: {
      // 页面标题title
      title: "关于我们"
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
